import React from 'react';
import './Loader.scss';

export const Loader = () => (
  <div
    className="Loader"
    data-cy="Loader"
  >
    <div className="Loader__content" />
  </div>
);
